export default __webpack_public_path__ + "static/media/reddit.87ca6dd3.gif";